
class CustomerReviewsCarousel {
  constructor() {
    this.container = document.querySelector('.mt-customer-reviews__carousel');
    this.prevButton = document.querySelector('.mt-customer-reviews__nav--prev');
    this.nextButton = document.querySelector('.mt-customer-reviews__nav--next');
    this.scrollbar = document.querySelector('.mt-customer-reviews__scrollbar');
    this.scrollbarThumb = document.querySelector('.mt-customer-reviews__scrollbar-thumb');
    
    if (!this.container) return;
    
    this.init();
  }
  
  init() {
    this.setupEventListeners();
    this.updateNavigationState();
  }
  
  setupEventListeners() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.scroll('prev'));
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.scroll('next'));
    }
    
    // 监听滚动事件来更新导航状态
    this.container.addEventListener('scroll', () => {
      this.updateNavigationState();
    });
    
    // 监听窗口大小变化
    window.addEventListener('resize', () => {
      this.updateNavigationState();
    });
  }
  
  scroll(direction) {
    const cardWidth = this.container.querySelector('.mt-customer-reviews__card')?.offsetWidth || 268;
    
    // 根据屏幕尺寸动态计算间距
    let gap;
    if (window.innerWidth <= 480) {
      gap = 16; // 小屏端
    } else if (window.innerWidth <= 768) {
      gap = 16; // 移动端
    } else {
      gap = 18; // 桌面端
    }
    
    const scrollAmount = cardWidth + gap;
    
    console.log('Scroll calculation:', {
      cardWidth,
      gap,
      scrollAmount,
      currentScroll: this.container.scrollLeft,
      maxScroll: this.container.scrollWidth - this.container.clientWidth,
      screenWidth: window.innerWidth
    });
    
    const currentScroll = this.container.scrollLeft;
    const maxScroll = this.container.scrollWidth - this.container.clientWidth;
    
    let newScroll;
    
    if (direction === 'prev') {
      newScroll = Math.max(0, currentScroll - scrollAmount);
    } else {
      newScroll = Math.min(maxScroll, currentScroll + scrollAmount);
    }
    
    this.container.scrollTo({
      left: newScroll,
      behavior: 'smooth'
    });
  }
  
  updateNavigationState() {
    if (!this.prevButton || !this.nextButton) return;
    
    const currentScroll = this.container.scrollLeft;
    const maxScroll = this.container.scrollWidth - this.container.clientWidth;
    
    // 更新上一页按钮状态
    this.prevButton.disabled = currentScroll <= 0;
    
    // 更新下一页按钮状态
    this.nextButton.disabled = currentScroll >= maxScroll;
    
    // 更新移动端滚动条
    this.updateScrollbar();
  }
  
  updateScrollbar() {
    // 只在移动端显示滚动条
    if (window.innerWidth > 768) {
      if (this.scrollbar) {
        this.scrollbar.style.display = 'none';
      }
      return;
    }
    
    if (!this.scrollbar || !this.scrollbarThumb) return;
    
    const currentScroll = this.container.scrollLeft;
    const maxScroll = this.container.scrollWidth - this.container.clientWidth;
    
    // 检查是否有滚动内容
    const hasOverflow = maxScroll > 0;
    
    if (hasOverflow) {
      this.scrollbar.style.display = 'block';
      
      // 计算滚动条位置
      const scrollPercentage = currentScroll / maxScroll;
      const thumbWidth = this.scrollbar.offsetWidth;
      const maxThumbLeft = thumbWidth - this.scrollbarThumb.offsetWidth;
      const thumbLeft = scrollPercentage * maxThumbLeft;
      
      this.scrollbarThumb.style.left = `${thumbLeft}px`;
    } else {
      this.scrollbar.style.display = 'none';
    }
  }
}

// 当DOM加载完成后初始化
document.addEventListener('DOMContentLoaded', () => {
  new CustomerReviewsCarousel();
});

// 如果页面使用Turbo或其他SPA框架，也需要监听页面变化
document.addEventListener('shopify:section:load', () => {
  new CustomerReviewsCarousel();
});

// 测试函数：检查导航箭头状态
window.testCustomerReviewsNav = function() {
  const prevButton = document.querySelector('.mt-customer-reviews__nav--prev');
  const nextButton = document.querySelector('.mt-customer-reviews__nav--next');
  
  console.log('Customer Reviews Navigation Test:');
  console.log('Previous button found:', !!prevButton);
  console.log('Next button found:', !!nextButton);
  
  if (prevButton) {
    console.log('Previous button disabled:', prevButton.disabled);
    console.log('Previous button has border:', prevButton.classList.contains('mt-customer-reviews__nav--bordered'));
  }
  
  if (nextButton) {
    console.log('Next button disabled:', nextButton.disabled);
    console.log('Next button has border:', nextButton.classList.contains('mt-customer-reviews__nav--bordered'));
  }
  
  // 检查容器
  const container = document.querySelector('.mt-customer-reviews__carousel');
  if (container) {
    console.log('Container scroll width:', container.scrollWidth);
    console.log('Container client width:', container.clientWidth);
    console.log('Container scroll left:', container.scrollLeft);
  }
};

// 测试函数：检查滑动距离计算
window.testCustomerReviewsScrollDistance = function() {
  const container = document.querySelector('.mt-customer-reviews__carousel');
  const card = container?.querySelector('.mt-customer-reviews__card');
  
  if (container && card) {
    const cardWidth = card.offsetWidth;
    
    // 根据屏幕尺寸动态计算间距
    let gap;
    if (window.innerWidth <= 480) {
      gap = 16; // 小屏端
    } else if (window.innerWidth <= 768) {
      gap = 16; // 移动端
    } else {
      gap = 18; // 桌面端
    }
    
    const scrollAmount = cardWidth + gap;
    
    console.log('Customer Reviews Scroll Distance Test:');
    console.log('Screen width:', window.innerWidth);
    console.log('Card width:', cardWidth);
    console.log('Gap:', gap);
    console.log('Scroll amount (one card):', scrollAmount);
    console.log('Container scroll width:', container.scrollWidth);
    console.log('Container client width:', container.clientWidth);
    console.log('Current scroll left:', container.scrollLeft);
    console.log('Max scroll:', container.scrollWidth - container.clientWidth);
  }
};

// 测试函数：检查滚动条状态
window.testCustomerReviewsScrollbar = function() {
  const scrollbar = document.querySelector('.mt-customer-reviews__scrollbar');
  const scrollbarThumb = document.querySelector('.mt-customer-reviews__scrollbar-thumb');
  const container = document.querySelector('.mt-customer-reviews__carousel');
  
  console.log('Customer Reviews Scrollbar Test:');
  console.log('Scrollbar found:', !!scrollbar);
  console.log('Scrollbar thumb found:', !!scrollbarThumb);
  console.log('Container found:', !!container);
  
  if (scrollbar) {
    console.log('Scrollbar display:', window.getComputedStyle(scrollbar).display);
    console.log('Scrollbar width:', scrollbar.offsetWidth);
  }
  
  if (scrollbarThumb) {
    console.log('Thumb left position:', scrollbarThumb.style.left);
    console.log('Thumb width:', scrollbarThumb.offsetWidth);
  }
  
  if (container) {
    const currentScroll = container.scrollLeft;
    const maxScroll = container.scrollWidth - container.clientWidth;
    console.log('Container scroll left:', currentScroll);
    console.log('Container max scroll:', maxScroll);
    console.log('Has overflow:', maxScroll > 0);
  }
};

// 测试函数：检查背景色设置
window.testCustomerReviewsBackgrounds = function() {
  const container = document.querySelector('.mt-customer-reviews__container');
  const cards = document.querySelectorAll('.mt-customer-reviews__card');
  
  console.log('Customer Reviews Background Test:');
  
  if (container) {
    const containerBg = window.getComputedStyle(container).backgroundColor;
    console.log('Container background color:', containerBg);
  }
  
  console.log('Number of cards found:', cards.length);
  
  cards.forEach((card, index) => {
    const cardBg = window.getComputedStyle(card).backgroundColor;
    console.log(`Card ${index + 1} background color:`, cardBg);
  });
};

// 测试函数：动态设置背景色
window.setCustomerReviewsBackgrounds = function(containerColor, cardColor) {
  const container = document.querySelector('.mt-customer-reviews__container');
  const cards = document.querySelectorAll('.mt-customer-reviews__card');
  
  if (container && containerColor) {
    container.style.backgroundColor = containerColor;
    console.log('Set container background to:', containerColor);
  }
  
  if (cards.length > 0 && cardColor) {
    cards.forEach((card, index) => {
      card.style.backgroundColor = cardColor;
    });
    console.log('Set all cards background to:', cardColor);
  }
};

// 测试函数：切换导航箭头边框样式
window.toggleCustomerReviewsNavBorder = function() {
  const navButtons = document.querySelectorAll('.mt-customer-reviews__nav');
  
  navButtons.forEach(button => {
    if (button.classList.contains('mt-customer-reviews__nav--bordered')) {
      button.classList.remove('mt-customer-reviews__nav--bordered');
      console.log('Removed border from navigation button');
    } else {
      button.classList.add('mt-customer-reviews__nav--bordered');
      console.log('Added border to navigation button');
    }
  });
}; 
